import React from 'react'
import { scaleLinear } from 'd3-scale'
import { LargeMap } from './large-map'

import s from './style.module.scss'

class MapPage extends React.Component {
  constructor(props) {
    super()
    this.mapProperties = null
    this.routePaths = {}
    this.pointsOfInterest = [
      {
        displayName: 'Brado',
        coordinates: [-73.994938888998, 40.69064436032289],
        offset: {
          x: 39.5,
          y: 83.5
        }
      },
      {
        displayName: 'Chez Moi',
        coordinates: [-73.99561641898245, 40.69083017761646],
        offset: {
          x: 32.5,
          y: 81.75
        }
      },
      {
        displayName: 'Marriott Hotel',
        coordinates: [-73.98803384936939, 40.69383597361195],
        offset: {
          x: 81,
          y: 59.5
        }
      }
    ]
    this.routes = {
      pathToVenues: {
        displayName: 'To Brado and Chez Moi',
        coordinates: [
          [-73.9886890449524, 40.693864252761784],
          [-73.98874626541138, 40.69295316593647],
          [-73.98990497970581, 40.69298570496616],
          [-73.99073467636109, 40.693029090314425],
          [-73.99273739242554, 40.6935930972707],
          [-73.99435387039186, 40.69023067750034],
          [-73.99538383865357, 40.69052354016141]
        ],
        directions: `
					Walk left out of the hotel, then cross to your right, over Adams St. Keep walking, past Borough Hall and down Remsen St. Take a left on Clinton St., and then, after five blocks, a right on Atlantic Ave.
				`,
        walkingTime: '12 mins',
        baseColor: '#1295D8',
        topColor: 'hsla(200, 85%, 30%, 1)'
      },
      pathToBKBridge: {
        displayName: 'To Brooklyn Bridge',
        coordinates: [
          [-73.9886890449524, 40.693864252761784],
          [-73.98862041218062, 40.694715669658414],
          [-73.98866059188538, 40.694999999999986],
          [-73.98862041218062, 40.696076382443934],
          // [-73.98867398512031, 40.6962997803946],
          [-73.98867398512031, 40.69628962595853],

          [-73.98871416482507, 40.69628962595853],
          [-73.98875434452984, 40.69640132466996],

          [-73.9887099, 40.697299010000016],
          [-73.98869004, 40.69769122],
          [-73.98861243, 40.69873461],
          [-73.9885729, 40.69919500000001],
          [-73.98858153, 40.69933162000002],
          [-73.98859536, 40.69938134000001],
          [-73.98859536, 40.69938134000001],
          [-73.98861593, 40.69945529999999],
          [-73.98866732, 40.69957891],
          [-73.98872741, 40.69968950999999],
          [-73.98882183, 40.699800110000005],
          [-73.98886908, 40.699868900000006],
          [-73.98908593, 40.70005258000001],
          [-73.98934294, 40.700214460000005],
          [-73.98951389, 40.70031416]
        ],
        directions: `
					Walk right out of the hotel and head up Adams St. After crossing Tillary St., cross Adams to the median, where you’ll find the pedestrian entrance to the Brooklyn Bridge. Walking across the bridge takes about 30 minutes.
				`,
        walkingTime: '5 mins',
        baseColor: '#1295D8',
        printColor: '#d91275',
        topColor: 'hsla(200, 85%, 30%, 1)'
      },
      pathToPromenade: {
        displayName: 'To Brooklyn Heights Promenade',
        coordinates: [
          [-73.9886890449524, 40.693864252761784],
          [-73.98874626541138, 40.69295316593647],
          [-73.98990497970581, 40.69298570496616],
          [-73.99073467636109, 40.693029090314425],
          [-73.99273739242554, 40.6935930972707],
          [-73.99462058142551, 40.69411654103785],
          [-73.99618758991134, 40.69451257581438],
          [-73.99771441869241, 40.694959381454055],
          [-73.99807603603529, 40.69506092777245],
          [-73.99827693455912, 40.69521324695986],
          [-73.99827693455912, 40.695314792891324]

          // [-73.99808942927022, 40.69506092777245],
          // [-73.99829032779404, 40.69521324695986],
          // [-73.99827693455912, 40.695314792891324]
        ],
        directions: `
					Walk left out of the hotel, then cross to your right, over Adams St. Keep walking, past Borough Hall and down Remsen St. Walk all the way down Remsen. You’ll see the entrance to the promenade on the right.
				`,
        walkingTime: '12 mins',
        baseColor: '#1295D8',
        topColor: 'hsla(200, 85%, 30%, 1)',
        printColor: 'gold',
        skipForPrint: true
      }
    }
    this.state = {
      currentRoute: null,
      POIPositions: null,
      forPrint: false
    }
  }

  scaleZoom(val) {
    const scale = scaleLinear()
      .domain([650, 1120])
      .range([1.8, 3])
    return scale(val)
  }

  handleClick(mapProperties) {
    this.stopAnimation()
    this.setState({
      currentRoute: null
    })
  }

  stopAnimation() {
    Object.keys(this.routePaths).map(key => {
      this.routePaths[key].style.strokeOpacity = 0
    })
  }

  handleRouteOptionClick(routeOption, e) {
    e.stopPropagation()
    this.setState({
      currentRoute: routeOption
    })
  }

  animateRoute(thePathNode) {
    var length = thePathNode.getTotalLength()
    // Clear any previous transition
    thePathNode.style.transition = thePathNode.style.WebkitTransition = 'none'
    // Set up the starting positions
    thePathNode.style.strokeDasharray = length + ' ' + length
    thePathNode.style.strokeDashoffset = length
    // Trigger a layout so styles are calculated & the browser
    // picks up the starting position before animating
    thePathNode.getBoundingClientRect()
    // Define our transition
    thePathNode.style.transition = thePathNode.style.WebkitTransition =
      'stroke-dashoffset 10s linear'
    thePathNode.style.strokeOpacity = 1
    // Go!
    thePathNode.style.strokeDashoffset = '0'
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.currentRoute &&
      this.state.currentRoute !== prevState.currentRoute
    ) {
      if (this.routePaths) {
        // hide all other active lines
        Object.keys(this.routePaths).map(key => {
          this.routePaths[key].style.strokeOpacity = 0
        })

        this.animateRoute(this.routePaths[this.state.currentRoute])
      }
    }
  }

  onRender(paths) {
    this.routePaths = {
      pathToVenues: paths[0],
      pathToBKBridge: paths[1],
      pathToPromenade: paths[2]
    }
  }

  render() {
    // 1120px --> 3
    let zoom = this.scaleZoom(
      typeof window !== 'undefined' ? window.innerWidth : 1200
    )

    const newroutes = {}
    Object.keys(this.routes).map(key => {
      if (!this.state.forPrint || !this.routes[key].skipForPrint) {
        newroutes[key] = this.routes[key]
      }
    })

    const routeOptions = (
      <div className={s.routeOptionWrapper}>
        {Object.keys(newroutes).map((key, i) => {
          return (
            <div
              key={i}
              className={s.routeOption}
              data-selected={this.state.currentRoute === key}
              onClick={this.handleRouteOptionClick.bind(this, key)}>
              <div>
                {newroutes[key].displayName}
                <span className={s.walkTime}>
                  {' '}
                  — {newroutes[key].walkingTime}
                </span>
              </div>
              {this.state.currentRoute === key && (
                <div className={s.directions}>{newroutes[key].directions}</div>
              )}
            </div>
          )
        })}
      </div>
    )

    let routeOptionsAbove =
      typeof window !== 'undefined' &&
      window.innerWidth !== 0 &&
      window.innerWidth > 600
        ? routeOptions
        : null
    let routeOptionsBelow =
      typeof window !== 'undefined' &&
      window.innerWidth !== 0 &&
      window.innerWidth <= 600
        ? routeOptions
        : null

    let labelMultiplier = 0.75
    if (typeof window !== 'undefined') {
      if (window.innerWidth < 700) {
        labelMultiplier = 0.6
      }
      if (window.innerWidth < 600) {
        labelMultiplier = 0.5
      }
      if (window.innerWidth === 0) {
        labelMultiplier = 0.75
      }
    }

    const labelFontSize =
      1271 /
      (typeof window !== 'undefined' && window.innerWidth
        ? window.innerWidth
        : 1271) *
      labelMultiplier

    return (
      <div>
        <header className={s.header}>
          <div className={s.mainHeading}>
            <h1>Getting around Brooklyn Heights</h1>
            <div className={s.pageDescription}>
              In Manhattan, there is a numbered grid of streets, which doesn’t
              exist in Brooklyn. But we do have long stretches (Henry, Hicks,
              Joralemon, Atlantic) that lead you to beautiful parks, charming
              stores, fun bars, and great restaurants. Brooklyn Heights is our
              home, and we are thrilled that you are here to see it.
            </div>
          </div>
          {routeOptionsAbove}
        </header>
        <div className={s.svgWrapper}>
          {this.pointsOfInterest.map((POI, i) => {
            return (
              <div
                key={i}
                className={s.POILabel}
                style={{
                  position: 'absolute',
                  top: `${POI.offset.y}%`,
                  left: `${POI.offset.x}%`
                }}>
                {POI.displayName}
              </div>
            )
          })}
          <LargeMap
            labelFontSize={`${labelFontSize}rem`}
            onRender={this.onRender.bind(this)}
            onClick={this.handleClick.bind(this)}
          />
        </div>
        {routeOptionsBelow}
      </div>
    )
  }
}

export default MapPage



// WEBPACK FOOTER //
// ./src/components/map-page/index.js